export default __webpack_public_path__ + "static/media/stoly3.fc5afa00.jpg";